export const rentVerificationColumns = [
  { name: 'date', label: 'Submitted', width: '25%' },
  { name: 'processingTime', label: 'Processing Time', width: '20%' },
  { name: 'status', label: 'Report Status', width: '25%' },
  { name: 'actions', label: 'Report Details', width: '30%' }
];
